import React, { Component } from "react";
import $ from "jquery";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { tokenVerification } from "./Utils";

export default class JournalViewResult extends Component {
  constructor() {
    super();

    this.state = {
      journalQuestions: [],
      journalTitle: localStorage.getItem("journalTitle"),
      dateBasedJournalEntries: [],
      summConfigObject: {
        sumOn: [],
      },
      showImagePopup: false,
      popupImageUrl: null,
      loadingImage: false,
    };
  }

  componentDidMount() {
    var thisController = this;

    setTimeout(() => {
      thisController.fetchJournalQuestions();
      thisController.fetchJournalSummationConfig();
    }, 300);
  }

  fetchJournalQuestions() {
    var thisController = this;
    let patientId = localStorage.getItem("patientId");

    $.ajax({
      url: "/my-jeeva-api/fetch-journal-item",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        answeredBy: patientId,
        journalId: localStorage.getItem("journalId"),
      },
      success: function (res) {
        if (res.success == true) {
          var resp = res.result;
          thisController.state.journalQuestions = resp;
          thisController.setState(thisController.state);
          thisController.questionLabelToObjectMap = {};
          const questionIdToObjectMap = {};
          resp.forEach((q) => {
            questionIdToObjectMap[q.id] = q;
          });

          thisController.questionIdToObjectMap = questionIdToObjectMap;
          thisController.setState(thisController.state);

          for (var i = 0; i < resp.length; i++) {
            var journalQuestion = resp[i];
            thisController.questionLabelToObjectMap[journalQuestion.label] =
              journalQuestion;
          }
          console.log(resp);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }


  fetchJournalAnswers() {
    var thisController = this;
    let patientId = localStorage.getItem("patientId");

    $.ajax({
      url: "/my-jeeva-api/fetch-journal-entry-byjournalid",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        journalId: localStorage.getItem("journalId"),
        answeredBy: patientId,
      },
      success: function (res) {
        if (res.success == true) {
          var date;
          var dateString;
          var dateJournalEntryMap = {};
          var journalEntries = res.result;
          var dayStartString;

          if (thisController.summConfigObject) {
            dayStartString = thisController.summConfigObject.startOfDay + ":00 AM";
            var dayStartTime = new Date("2000-01-01 " + dayStartString);
          } else {
            dayStartString = "12:00 AM";
            var dayStartTime = new Date("2000-01-01 " + dayStartString);
          }

          journalEntries.forEach((journalEntry) => {
            journalEntry.answerJsonRecord = JSON.parse(journalEntry.answersJson);

            for (const questionId in journalEntry.answerJsonRecord) {
              const answerValue = journalEntry.answerJsonRecord[questionId];
              const questionObj = thisController.questionIdToObjectMap
                ? thisController.questionIdToObjectMap[questionId]
                : null;

              if (
                questionObj &&
                questionObj.type &&
                questionObj.type.toUpperCase() === "IMAGE" &&
                answerValue
              ) {
                journalEntry.answerJsonRecord[questionId] = {
                  type: "IMAGE",
                  mediaId: answerValue,
                  url: `/my-jeeva-api/fetch-media-by-id?mediaId=${answerValue}`,
                };
              }
            }


            var hasCustomDateOrTime = false;
            var patientAnswerTime;
            var dateTimeZone = new Date(journalEntry.answeredOn);
            var timeZone = journalEntry.timeZone;

            if (timeZone) {
              var options = {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
                timeZone: timeZone,
              };
              patientAnswerTime = new Intl.DateTimeFormat("en-US", options).format(dateTimeZone);
            } else {
              patientAnswerTime = new Date(journalEntry.answeredOn);
            }

            var customDateString = false;
            if (thisController.summConfigObject) {
              if (
                thisController.summConfigObject.sumBy != "systemDate" &&
                thisController.summConfigObject.sumBy.length > 0
              ) {
                var sumByKey = thisController.summConfigObject.sumBy;
                var sumByQuestionId =
                  thisController.questionLabelToObjectMap[sumByKey].id;
                var customPatientDataDateString =
                  journalEntry.answerJsonRecord[sumByQuestionId];
                if (customPatientDataDateString) {
                  customDateString = customPatientDataDateString;
                  hasCustomDateOrTime = true;
                }
              }
            }

            var customTimeString = false;
            if (thisController.summConfigObject) {
              if (
                thisController.summConfigObject.sumByTime != "systemTime" &&
                thisController.summConfigObject.sumByTime.length > 0
              ) {
                var sumByTimeKey = thisController.summConfigObject.sumByTime;
                if (sumByTimeKey) {
                  var sumByTimeQuestionId =
                    thisController.questionLabelToObjectMap[sumByTimeKey].id;
                  var customPatientDataTimeString =
                    journalEntry.answerJsonRecord[sumByTimeQuestionId];
                  if (customPatientDataTimeString) {
                    if (customPatientDataTimeString.includes("undefined")) {
                      customPatientDataTimeString =
                        customPatientDataTimeString.replace(" undefined", "");
                      journalEntry.answerJsonRecord[sumByTimeQuestionId] =
                        customPatientDataTimeString;
                    }
                    customTimeString = customPatientDataTimeString + ":00";
                    hasCustomDateOrTime = true;
                  }
                }
              }
            }

            var dataDate = thisController.getDateAsSimpleString(
              patientAnswerTime,
              timeZone
            );
            var dataTime = thisController.getHourAndTimeAsString(
              patientAnswerTime,
              timeZone
            );

            if (customDateString !== false) {
              dataDate = customDateString;
            }
            if (customTimeString !== false) {
              dataTime = customTimeString;
            }

            if (hasCustomDateOrTime === true) {
              var dataDateAndTime = dataDate + " " + dataTime;
              patientAnswerTime = new Date(dataDateAndTime);
              journalEntry.answeredOn = patientAnswerTime.getTime();
            }

            var timeInMinutesSince12am =
              thisController.getTimeInMinuteSince12Am(patientAnswerTime, timeZone);
            var dayStartInMinsSince12am =
              dayStartTime.getHours() * 60 + dayStartTime.getMinutes();

            if (timeInMinutesSince12am < dayStartInMinsSince12am) {
              var actualDate;
              if (timeZone) {
                actualDate = thisController.getActualDate(patientAnswerTime, timeZone);
                if (typeof patientAnswerTime === "string") {
                  var dateObj = patientAnswerTime;
                  dateObj = new Date(dateObj);
                }
                var options = {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: false,
                  timeZone: timeZone,
                };
                var formattedDate = new Intl.DateTimeFormat("en-US", options).format(dateObj);
                var dateFormat = new Date(formattedDate);
                dateObj.setDate(dateFormat.getDate() - 1);
                patientAnswerTime = dateObj;
              } else {
                actualDate = new Date(patientAnswerTime.getTime());
                patientAnswerTime.setDate(patientAnswerTime.getDate() - 1);
              }
              journalEntry.actualDate = thisController.getDateAsSimpleString(actualDate, timeZone);
            }

            dateString = thisController.getDateAsSimpleString(
              patientAnswerTime,
              timeZone
            );

            if (!dateJournalEntryMap[dateString]) {
              dateJournalEntryMap[dateString] = [];
            }
            dateJournalEntryMap[dateString].push(journalEntry);
          });

          console.log("Summation config:" + thisController.summConfigObject);

          if (thisController.summConfigObject) {
            var sumOnFields = thisController.summConfigObject.sumOn;
            if (sumOnFields.length > 0 && sumOnFields[0].label != "") {
              for (dateString in dateJournalEntryMap) {
                var sumRow = {};
                sumRow.answeredOn = "Total";
                sumRow.answerJsonRecord = {};
                var dateJournalRows = dateJournalEntryMap[dateString];

                for (var sumOnIndex = 0; sumOnIndex < sumOnFields.length; sumOnIndex++) {
                  var sumOnField = sumOnFields[sumOnIndex].label;
                  if (sumOnField) {
                    if (thisController.questionLabelToObjectMap[sumOnField]) {
                      var questionId =
                        thisController.questionLabelToObjectMap[sumOnField].id;
                      console.log("Calculating sum of " + sumOnField);
                      var sum = 0;
                      for (var entryIndex = 0; entryIndex < dateJournalRows.length; entryIndex++) {
                        var answerJsonRecord =
                          dateJournalRows[entryIndex].answerJsonRecord;
                        var sumOnFieldValue = answerJsonRecord[questionId]
                          ? answerJsonRecord[questionId]
                          : 0;
                        sum += Number(sumOnFieldValue);
                      }
                      sumRow.answerJsonRecord[questionId] = sum;
                      console.log(
                        "Calculated sum of " +
                        sumOnField +
                        " for " +
                        dateString +
                        " is " +
                        sum
                      );
                    }
                  }
                }
                dateJournalRows.push(sumRow);
              }
            }
          }

          var dateJournalEntries = [];
          var dateJournalEntry;
          for (dateString in dateJournalEntryMap) {
            dateJournalEntry = {
              date: dateString,
              entries: dateJournalEntryMap[dateString],
            };
            dateJournalEntries.push(dateJournalEntry);
          }

          thisController.state.dateBasedJournalEntries = dateJournalEntries;
          thisController.setState(thisController.state);
        }
      },
      error: function (xhr, status, error) {
        if (xhr.status == 401) tokenVerification();
      },
    });
  }



  getDateAsSimpleString(dateObj, timeZone) {
    if (timeZone) {
      if (!(dateObj instanceof Date)) {
        dateObj = new Date(dateObj);
      }

      var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: timeZone
      };

      return new Intl.DateTimeFormat('en-US', options).format(dateObj);
    } else {
      var month = dateObj.getMonth() + 1;
      var day = dateObj.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      return month + "/" + day + "/" + dateObj.getFullYear();
    }
  }

  getHourAndTimeAsString(dateObj, timeZone) {
    if (timeZone) {
      if (!(dateObj instanceof Date)) {
        dateObj = new Date(dateObj);
      }

      var options = {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timeZone
      };

      return new Intl.DateTimeFormat('en-US', options).format(dateObj);
    } else {
      return dateObj.getHours() + ":" + dateObj.getMinutes() + ":00";
    }
  }

  getTimeInMinuteSince12Am(dateObj, timeZone) {
    if (typeof dateObj === 'string') {
      dateObj = new Date(dateObj);
    }
    if (timeZone) {
      var options = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: timeZone
      };

      var formattedTime = new Intl.DateTimeFormat('en-US', options).formatToParts(dateObj);
      let hours = parseInt(formattedTime.find(part => part.type === 'hour').value);
      let minutes = parseInt(formattedTime.find(part => part.type === 'minute').value);

      let totalMinutesSince12AM = hours * 60 + minutes;
      return totalMinutesSince12AM
    } else {
      return dateObj.getHours() * 60 + dateObj.getMinutes()
    }
  }

  getActualDate(dateObj, timeZone) {
    if (timeZone) {
      if (typeof dateObj === 'string') {
        dateObj = new Date(dateObj);
      }
      var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: timeZone
      };

      return new Intl.DateTimeFormat('en-US', options).format(dateObj);
    }
  }

  fetchJournalSummationConfig() {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/get-journal-Summation",
      method: "GET",
      data: {
        journalId: localStorage.getItem("journalId"),
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          console.log("response object: ", res.result);
          var summConfigObject = res.result;
          var selectedData = summConfigObject.sumOn.split(",");
          var sumOnArray = [];
          for (let label of selectedData) {
            sumOnArray.push({ label });
          }
          summConfigObject = { ...summConfigObject, sumOn: sumOnArray };
          thisController.summConfigObject = summConfigObject;
        }
        thisController.fetchJournalAnswers();
      },
    });
  }


  formatTime(longDate, timeZone) {
    var totalString = "Total";
    if (longDate == totalString) {
      return totalString;
    }
    var strTime;
    var date = new Date(longDate);
    if (timeZone) {
      var options = {
        hour: '2-digit',
        minute: '2-digit',
        // hour12: true,
        hour12: false,
        timeZone: timeZone
      };
      strTime = new Intl.DateTimeFormat('en-US', options).format(date);
    } else {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      strTime = hours + ":" + minutes;
      if (ampm === "pm") {
        if (hours !== 12) {
          hours = parseInt(hours) + 12; // Add 12 to hours if pm and not already 12
        }
        strTime = hours + ":" + minutes;
      }
      else {
        if (hours === 12) {
          hours = "00"; // Change 12 AM to 00 AM
        }
        strTime = hours + ":" + minutes;
      }
    }
    return strTime;
  }

  extractCellValueAndColor(answersJsonRecord, questionId, type, answeredOn, journalQuestions) {
    var value = answersJsonRecord[questionId];
    var backgroundColor = ""; // Initialize background color
    var color = "";

    if (Array.isArray(value)) {
      value = value.join(","); // Join array elements with comma
    }

    if (!value) {
      if (type === "INTEGER") {
        value = "NA";
      } else {
        value = "NA";
      }
    }

    // Logic to change background color
    if (answeredOn === "Total") {
      var jsonObject = answersJsonRecord;
      if (jsonObject) {
        for (var key in jsonObject) {
          if (jsonObject.hasOwnProperty(key)) {
            var answerKey = key
            if (answerKey === questionId) {
              for (var keyIndex = 0; keyIndex < journalQuestions.length; keyIndex++) {
                if (journalQuestions[keyIndex].id === questionId) {
                  var value = jsonObject[answerKey];
                  console.log("Key: " + answerKey + ", Value: " + value);
                  var threshold = journalQuestions[keyIndex].threshold;
                  console.log("threshold", threshold);
                  if (threshold && value > 0) {
                    var result = (value / threshold) * 100;
                    console.log("result", result);
                    if (result > 100) {
                      backgroundColor = "red";
                      color = "white";

                    } else if (result < 100 && result >= 75) {
                      backgroundColor = "yellow";
                      color = "black"
                    } else {
                      backgroundColor = "green";
                      color = "white";

                    }
                  }
                }
              }

            }
          }

        }
      }

    }

    return { value, backgroundColor, color };
  }


  // getColumns(dateBasedJournalEntry) {
  //   console.log(dateBasedJournalEntry.date);
  //   var thisController = this;
  //   var columns = [
  //     {
  //       name: <b style={{ fontSize: "16px" }}>{dateBasedJournalEntry.date}</b>,
  //       selector: (props) => {
  //         return (
  //           <div
  //             className="textarea"
  //             style={{
  //               background: "white",
  //               height: "2.7em",
  //               resize: "none",
  //               paddingLeft: "13px",
  //               paddingTop: "6px",
  //               width: "100%",
  //               border: "none",
  //               borderRadius: "2px",
  //               textAlign: "center",
  //             }}
  //           >
  //             {thisController.formatTime(props.answeredOn, props.timeZone)}
  //           </div>
  //         );
  //       },
  //     },
  //   ];
  //   var journalQuestion;

  //   for (var i = 0; i < this.state.journalQuestions.length; i++) {
  //     journalQuestion = this.state.journalQuestions[i];
  //     console.log("Adding column header : " + journalQuestion.label);

  //     columns.push({
  //       name: <b style={{ fontSize: "16px" }}>{journalQuestion.label}</b>,
  //       selector: (function (journalQuestion) {
  //         return (props) => {
  //           var result = thisController.extractCellValueAndColor(
  //             props.answerJsonRecord,
  //             journalQuestion.id,
  //             journalQuestion.type,
  //             props.answeredOn,
  //             thisController.state.journalQuestions
  //           );

  //           var threshold = journalQuestion.threshold;
  //           if (threshold) {
  //             var backgroundColor = threshold ? result.backgroundColor : "white"; // Set background color only if threshold exists
  //             var color = threshold ? result.color : "black";
  //           } else {
  //             backgroundColor = "white";
  //             color = "black";
  //           }

  //           return (
  //             <div
  //               className="textarea"
  //               style={{
  //                 background: backgroundColor, // Set background color here
  //                 height: "2.7em",
  //                 resize: "none",
  //                 paddingLeft: "13px",
  //                 paddingTop: "6px",
  //                 width: "100%",
  //                 border: "none",
  //                 borderRadius: "2px",
  //                 textAlign: "center",
  //                 color: color
  //               }}
  //             >
  //               {result.value}
  //             </div>
  //           );
  //         };
  //       })(journalQuestion),
  //     });
  //   }

  //   return columns
  // }

  getColumns(dateBasedJournalEntry) {
    console.log(dateBasedJournalEntry.date);
    var thisController = this;

    var columns = [
      {
        name: <b style={{ fontSize: "16px" }}>{dateBasedJournalEntry.date}</b>,
        selector: (props) => {
          return (
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "13px",
                paddingTop: "6px",
                width: "100%",
                border: "none",
                borderRadius: "2px",
                textAlign: "center",
              }}
            >
              {thisController.formatTime(props.answeredOn, props.timeZone)}
            </div>
          );
        },
      },
    ];

    var journalQuestion;

    for (var i = 0; i < this.state.journalQuestions.length; i++) {
      journalQuestion = this.state.journalQuestions[i];
      console.log("Adding column header : " + journalQuestion.label);

      columns.push({
        name: <b style={{ fontSize: "16px" }}>{journalQuestion.label}</b>,
        selector: ((journalQuestion) => {
          return (props) => {
            const answer = props.answerJsonRecord[journalQuestion.id];
            const threshold = journalQuestion.threshold;
            let backgroundColor = "white";
            let color = "black";
            let displayValue = "-";

            if (answer && typeof answer === "object" && answer.type === "IMAGE") {
              return (
                <div style={{ textAlign: "center" }}>
                  <img
                    src={answer.url}
                    alt="journal"
                    width="40"
                    height="40"
                    style={{
                      borderRadius: "6px",
                      cursor: "pointer",
                      objectFit: "cover",
                      border: "1px solid #ccc",
                    }}
                    onClick={() => thisController.openImagePopup(answer.url)}
                  />
                </div>
              );
            }

            const result = thisController.extractCellValueAndColor(
              props.answerJsonRecord,
              journalQuestion.id,
              journalQuestion.type,
              props.answeredOn,
              thisController.state.journalQuestions
            );

            if (threshold) {
              backgroundColor = result.backgroundColor || "white";
              color = result.color || "black";
            }

            displayValue =
              typeof result.value === "object"
                ? result.value.value || "-"
                : result.value || "-";

            return (
              <div
                className="textarea"
                style={{
                  background: backgroundColor,
                  height: "2.7em",
                  resize: "none",
                  paddingLeft: "13px",
                  paddingTop: "6px",
                  width: "100%",
                  border: "none",
                  borderRadius: "2px",
                  textAlign: "center",
                  color: color,
                }}
              >
                {displayValue}
              </div>
            );
          };
        })(journalQuestion),
      });
    }

    return columns;
  }

  // openImagePopup = (url) => {
  //   this.setState({
  //     showImagePopup: true,
  //     popupImageUrl: url,
  //   });
  // };

  openImagePopup = (url) => {
    this.setState({
      showImagePopup: true,
      popupImageUrl: null,
      loadingImage: true,
    });

    const img = new Image();
    img.src = url;

    img.onload = () => {
      this.setState({
        popupImageUrl: url,
        loadingImage: false,
      });
    };

    img.onerror = () => {
      this.setState({ loadingImage: false });
      alert("Failed to load image. Please try again.");
    };
  };

  closeImagePopup = () => {
    this.setState({
      showImagePopup: false,
      popupImageUrl: null,
    });
  };



  render() {

    const customStyles = {
      headCells: {
        style: {
          justifyContent: "center",
        },
      },

      cells: {
        style: {
          justifyContent: "center",
        },
      },
    };

    return (

      <div style={{ height: "60vh" }}>
        <link rel="stylesheet" href="assets/css/DashBoardGraph.css" />

        <div
          style={{
            display: "flex",
            justifyContent: "start",
            marginTop: "10px",
          }}
        >
          <Link to="/projectmgmt/journal/view-result">
            <img
              className="img-responsive"
              src="./assets/images/arrow.svg"
              style={{ marginLeft: "5px", cursor: "pointer" }}
            />
          </Link>

          {/* <h6
            className="nav-item"
            style={{ color: "#282a65", marginTop: "4px", marginLeft: "1vh" }}
          >
            {localStorage.getItem("journalTitle")} - Entries of {this.props.location.state.patientName}
          </h6> */}
        </div>
        <div className="patient-info-container">
          <div className="patient-info-box">
            <strong>Patient Name</strong>
            <p>{localStorage.getItem("patientName")}</p>
          </div>
          <div className="patient-info-box">
            <strong>Journal Name</strong>
            <p>{localStorage.getItem("journalTitle")}</p>
          </div>
          <div className="patient-info-box">
            <strong>Treatment Name</strong>
            <p>{localStorage.getItem("procedureName")}</p>
          </div>
        </div>
        <br></br>

        {this.state.dateBasedJournalEntries ? (
          this.state.dateBasedJournalEntries.map((dateBasedJournalEntry) => (
            <div
              style={{
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
                marginBottom: "10px",
                marginRight: "2vw",
              }}
            >
              <DataTable
                columns={this.getColumns(dateBasedJournalEntry)}
                data={dateBasedJournalEntry.entries}
                customStyles={customStyles}
              />
              {/* {this.state.showImagePopup && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.75)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999,
                  }}
                  onClick={this.closeImagePopup} 
                >
                  <div
                    style={{
                      position: "relative",
                      background: "white",
                      padding: "10px",
                      borderRadius: "10px",
                      maxWidth: "90%",
                      maxHeight: "90%",
                    }}
                    // onClick={(e) => e.stopPropagation()} 
                  >
                    <button
                      onClick={this.closeImagePopup}
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "10px",
                        background: "rgba(0,0,0,0.6)",
                        color: "white",
                        border: "none",
                        borderRadius: "50%",
                        width: "28px",
                        height: "28px",
                        cursor: "pointer",
                        fontSize: "18px",
                      }}
                    >
                      ×
                    </button>

                    <img
                      src={this.state.popupImageUrl}
                      alt="Preview"
                      style={{
                        maxWidth: "180vw",
                        maxHeight: "180vh",
                        // borderRadius: "10px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                </div>
              )} */}

              {this.state.showImagePopup && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.75)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999,
                  }}
                  onClick={this.closeImagePopup}
                >
                  <div
                    style={{
                      position: "relative",
                      background: "white",
                      padding: "10px",
                      borderRadius: "10px",
                      maxWidth: "90%",
                      maxHeight: "90%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={(e) => e.stopPropagation()} // Prevent popup close when clicking inside
                  >
                    {/* Show loader while image is loading */}
                    {this.state.loadingImage ? (
                      <div style={{ color: "#333", fontSize: "16px" }}>Loading image...</div>
                    ) : (
                      <div>
                        {/* Show close button only after image is loaded */}
                        <button
                          onClick={this.closeImagePopup}
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "10px",
                            background: "rgba(0,0,0,0.6)",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            width: "28px",
                            height: "28px",
                            cursor: "pointer",
                            fontSize: "18px",
                          }}
                        >
                          ×
                        </button>

                        <img
                          src={this.state.popupImageUrl}
                          alt="Preview"
                          style={{
                            maxWidth: "90vw",
                            maxHeight: "90vh",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div>No Records found for this Journal</div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/JournalViewResult.js